<ion-header class="ion-no-border">
  <ion-toolbar mode="md" class="pl-5 pr-3">
    <div class="flex items-end pb-3 justify-between">
      <ion-button
        mode="ios"
        fill="clear"
        (click)="goBack()"
        slot="start"
        [color]="!isWeb ? 'light' : 'secondary'"
      >
        <ion-icon
          slot="icon-only"
          class="text-lg"
          src="../../../../assets/svg/arrowLeft.svg"
        />
      </ion-button>
      <div class="flex items-center">
        <ion-button
          *ngIf="mode !== 'commission'"
          mode="ios"
          fill="clear"
          [color]="!isWeb ? 'light' : 'secondary'"
          (click)="sharePost()"
        >
          <ion-icon
            slot="icon-only"
            class="text-2xl"
            src="../../../../assets/svg/share.svg"
          />
        </ion-button>
        <ion-button
          *ngIf="mode !== 'commission' && !isOwner()"
          mode="ios"
          fill="clear"
          [color]="!isWeb ? 'light' : 'secondary'"
          (click)="openOptions($event)"
        >
          <ion-icon
            class="text-2xl"
            name="ellipsis-vertical"
            slot="icon-only"
          ></ion-icon>
        </ion-button>
      </div>
    </div>
  </ion-toolbar>
</ion-header>

<ion-popover
  [isOpen]="showOptions"
  [event]="optionsEvent"
  (didDismiss)="showOptions = false"
  arrow="false"
  dismissOnSelect="true"
  mode="ios"
>
  <ng-template>
    <ion-content class="ion-padding" scroll-y="false">
      <div class="flex items-center gap-2" (click)="report()">
        <ion-icon
          src="../../../assets/svg/alert.svg"
          color="secondary"
        ></ion-icon>
        <ion-label color="secondary" class="text-[11px] uppercase pb-1"
          >{{ "DETAILS_HEADER.REPORT_CONTENT" | translate }}
        </ion-label>
      </div>
    </ion-content>
  </ng-template>
</ion-popover>

<app-dialog
  [show]="show"
  type="accept"
  (toggle)="show = false"
  (confirm)="confirm()"
  [close]="true"
>
  <ion-label
    class="text-[13px] mt-4 text-[#131C4F]"
    [innerHTML]="'DETAILS_HEADER.LOGIN_REQUIRED_MESSAGE' | translate"
  ></ion-label>
</app-dialog>

<!-- Share Dialog (fallback) -->
<app-dialog
  [show]="showShareDialog"
  type="accept"
  (toggle)="closeShareDialog()"
  (confirm)="copyShareLink()"
  [close]="true"
  buttonText="{{ 'COPY' | translate }}"
>
  <div class="px-3">
    <h4 class="text-center font-medium text-base mb-2">
      {{ "DETAILS_HEADER.SHARE_CONTENT" | translate }}
    </h4>
    <div class="share-link-container bg-gray-100 p-3 rounded-md mb-3">
      <div class="flex items-center justify-between">
        <div class="overflow-hidden max-w-[85%]">
          <p class="text-sm text-gray-700 break-all">{{ shareLink }}</p>
        </div>
        <ion-button
          fill="clear"
          class="flex-shrink-0 ml-2"
          (click)="copyShareLink()"
        >
          <ion-icon
            name="copy-outline"
            class="text-lg text-gray-500"
          ></ion-icon>
        </ion-button>
      </div>
    </div>
  </div>
</app-dialog>
